import { trackEvent } from '@patrianna/analytics'
import { useIsMobile, useSocialButtonSpinner } from '@patrianna/shared-hooks'
import type { SocialAuthTypes } from '@patrianna/shared-patrianna-types/store/AuthModule'
import { getAuthFlowLoadingSelector } from '@patrianna/shared-store/auth'
import { Apple } from '@patrianna-icons/material-icons'
import cx from 'classnames'
import { usePathname, useSearchParams } from 'next/navigation'

import { appleAuth } from 'services/apple/actions'
import Button from 'src/components/Button'
import Loader from 'src/components/Loader'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'

import { useRouterPushWithCallback } from '../NavigationProvider'

import classes from './styles.module.scss'

type Props = {
  title: string
  authType: SocialAuthTypes
  disabled?: boolean
  skipTrackEvent?: boolean
}

export default function AppleButton(props: Props) {
  const routerPush = useRouterPushWithCallback()
  const query = useSearchParams()
  const pathname = usePathname()
  const dispatch = useAppDispatch()
  const isLoading = useAppSelector(getAuthFlowLoadingSelector)
  const { isSendRequest, setIsSendRequest } = useSocialButtonSpinner(isLoading)
  const isMobile = useIsMobile()

  const onClick = () => {
    setIsSendRequest(true)
    dispatch(appleAuth(props.authType, isMobile, routerPush, query, pathname))

    if (!props.skipTrackEvent) {
      trackEvent('login_page_apple_button')
    }
  }

  return (
    <Button
      disabled={props.disabled || isLoading}
      className={cx(classes.root, isSendRequest && classes.loading)}
      onClick={onClick}
    >
      {isSendRequest && isLoading ? (
        <Loader size={28} />
      ) : (
        <>
          <span className={classes.buttonBox}>
            <Apple className={classes.icon} />
            <span className={classes.text}>{props.title}</span>
          </span>
        </>
      )}
    </Button>
  )
}
